import MaskedInput from '@r1-frontend/ui-react/components/input';
import clone from 'lodash/clone';
import React, { Fragment, useCallback, useMemo } from 'react';
import Creatable from 'react-select/creatable';

import InputSimple, { phoneDecorator } from '../../inputSimple';
import { replaceValueForPhone } from '../../inputSimple/decorators/helpers/phoneDecorator';
import {
    ClearIndicator,
    Control,
    customStyles,
    DropdownIndicator,
    Menu,
    MenuList,
    Option,
} from '../dropdown';
import Select from '../select';

export function CreatablePhoneSelectV2({
    options,
    placeholder = 'Выберите телефон',
    createOptionPosition = 'first',
    label = '7',
    ...rest
}) {
    const innerOptions = useMemo(() => {
        return options.map((option) => {
            return {
                ...option,
                label: label + option.label.toString().substring(1),
            };
        });
    }, [options]);

    return <Creatable
        styles={customStyles}
        components={{
            IndicatorSeparator: null,
            ClearIndicator,
            Control,
            DropdownIndicator,
            Menu,
            MenuList,
            Option,
        }}
        formatCreateLabel={formatCreateLabel}
        createOptionPosition={createOptionPosition}
        placeholder={placeholder}
        options={innerOptions}
        onInputChange={handleInputChange}
        {...rest}
    />;
}

/**
 * @param {string} value
 * @returns {string}
 */
function formatCreateLabel(value) {
    return 'Новый телефон ' + value;
}

/**
 * @param {string} inputValue
 * @param {{action:string}} meta
 * @returns {string|*}
 */
function handleInputChange(inputValue, meta) {
    if (meta.action === 'input-change') {
        return replaceValueForPhone(inputValue);
    }
    return inputValue;
}

const InputPhone = phoneDecorator(InputSimple);

export function CreatablePhoneSelect({
    options,
    onChange,
    value,
    inputValue,
    onInputChange,
    placeholder = 'Выберите телефон',
    inputPlaceHolder = 'Номер телефона',
    createLabel = 'Указать телефон',
    createValue = -1,
    errorMessage = 'Введите телефон в формате +7 (999) 999-99-99',
    onMenuOpen = () => ({}),
    onMenuClose = () => ({}),
    masked,
    hasError,
}) {
    const clonedOptions = useMemo(() => {
        const clonedOptionsInner = clone(options);

        clonedOptionsInner.push({
            label: createLabel,
            value: createValue,
        });

        return clonedOptionsInner;
    }, [options, createLabel, createValue]);

    const isShowInput = value && value.value === createValue;

    const onMaskedInputChange = useCallback(
        (value) =>
            onInputChange({
                value,
                label: value,
            }),
        [onInputChange],
    );

    const inputProps = {
        value: inputValue,
        placeholder: inputPlaceHolder,
        onChange: masked ? onMaskedInputChange : onInputChange,
        errorMessage: errorMessage,
        className: 'ym-disable-keys',
        hasError: hasError,
    };

    return <Fragment>
        <Select
            options={clonedOptions}
            onChange={onChange}
            value={value}
            placeholder={placeholder}
            onMenuOpen={onMenuOpen}
            onMenuClose={onMenuClose}
        />
        {
            isShowInput && (masked
                ? <MaskedInput type='phone' {...inputProps} />
                : <InputPhone {...inputProps} />
            )
        }
    </Fragment>;
}
